import { useEffect, useState } from "react";
import { adminApi, type AuditLogEntry } from "../lib/admin-api";

export default function AuditLog() {
  const [entries, setEntries] = useState<AuditLogEntry[]>([]);

  useEffect(() => {
    adminApi.getAuditLog().then((r) => setEntries(r.entries));
  }, []);

  return (
    <div className="stack">
      <h2>Audit log</h2>
      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>When</th>
                <th>Actor</th>
                <th>Action</th>
                <th>Entity</th>
              </tr>
            </thead>
            <tbody>
              {entries.map((e) => (
                <tr key={e.id}>
                  <td>{new Date(e.created_at).toLocaleString("en-GB")}</td>
                  <td>{e.actor}</td>
                  <td>{e.action}</td>
                  <td>{e.entity_type ? `${e.entity_type} · ${e.entity_id}` : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
